import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby';

import headerStyles from '../styles/components/header.module.scss'

const Header = () => {
    //graphQl
    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `)
    return (
        <header className={headerStyles.header}>
            <div className={headerStyles.titleContainer}>
                <Link className={headerStyles.title} to ="/">
                    {data.site.siteMetadata.title}
                </Link>
            </div>
                <nav className={headerStyles.navContainer}>
                    <ul className={headerStyles.navList}>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/#Intro">#intro</Link>
                        </li>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to ="/#About">#about</Link>
                        </li>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to ="/#Skills">#skills</Link>
                        </li>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/#Contact">#contact</Link>
                        </li>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to ="/projectsPage">#projects</Link>
                        </li>
                        <li>
                            <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to ="/blog">#blog</Link>
                        </li>
                            <a href = "/404"  rel="noreferrer" target="_blank"><button className={headerStyles.newsletter}>Newsletter</button></a>
                    </ul>
                </nav>
        </header>
    )
}

export default Header;